export default {
  // 検索エリア
  drawTime: '抽選時間',
  startTime: '開始時間',
  endTime: '終了時間',
  member_keyword: 'ユーザー情報',
  member_keywordPlaceholder: 'ユーザー名またはUIDを入力してください',
  code: 'QRコード番号',
  codePlaceholder: 'QRコード、防偽コードまたはシリアルコードを入力してください',
  is_award: '当選ステータス',
  is_awardPlaceholder: '選択してください',
  is_awardWon: '当選',
  is_awardNotWon: '落選',
  activity_keyword: 'アクティビティ情報',
  activity_keywordPlaceholder: 'アクティビティ名またはIDを入力してください',
  country_id: 'スキャン国/地域',
  country_idPlaceholder: '選択してください',
  search: '検索',
  // テーブル列
  colUserInfo: 'ユーザー情報',
  colQrcode: 'QRコード',
  colActivityInfo: 'アクティビティ情報',
  colWinStatus: '当選ステータス',
  colPrize: '賞品',
  colDrawTime: '抽選時間',
  colDrawRegion: '抽選地域',
  colAction: '操作',
  // 操作
  detail: '詳細',
  // 詳細モーダル
  detailTitle: '抽選詳細',
  sectionMemberInfo: '当選者情報',
  sectionActivityInfo: 'アクティビティ情報',
  sectionScanInfo: 'スキャン情報',
  detailMemberId: 'ユーザーID',
  detailMemberName: 'ユーザー名',
  detailPhone: '電話番号',
  detailActivityId: 'アクティビティID',
  detailActivityName: 'アクティビティ名',
  detailWinPrize: '当選賞品',
  detailWinStrategy: '当選戦略',
  detailAwardStatus: '賞品受取状態',
  detailPrizeContent: '賞品内容',
  prizeGift: 'ギフト',
  prizePoint: 'ポイント',
  detailCode: 'QRコード',
  detailCodeBatch: 'コードバッチ',
  detailProduct: '関連製品',
  detailScanTime: 'スキャン時間',
  detailScanRegion: 'スキャン国/地域',
  // プレースホルダー
  dash: '——',
  // 空状態
  emptyText: '抽選記録がありません',
};
